// AI assistants, search engines and their parent companies are never
// competitors: never ranked, counted, suggested or shown as a leader.
const EXCLUDED = [
  "google", "gemini", "bard", "alphabet", "microsoft", "bing", "copilot", "openai", "chatgpt", "gpt",
  "anthropic", "claude", "perplexity", "meta", "facebook", "llama", "grok", "xai", "x ai", "duckduckgo", "yahoo",
];

const norm = (s: string) => s.toLowerCase().replace(/https?:\/\/|www\./g, "").replace(/\.(com|ai|org|net|io)\b.*$/, "").replace(/[^a-z0-9]+/g, " ").trim();

/** True for "Google", "Google AI Overviews", "Microsoft Copilot", "openai.com", "Meta AI"... */
export function isExcludedBrand(name: string | null | undefined): boolean {
  if (!name) return false;
  const n = norm(name);
  if (!n) return false;
  const first = n.split(" ")[0];
  return EXCLUDED.includes(n) || EXCLUDED.includes(first);
}
